import { CommonAPIService } from "src/servicehandlers/CommonHandler";

export class TasksAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  listTaskStatuses(router) {
    const url = "/api/taskStatuses";
    return this.CommonAPIService.getCall(url, "", router);
  }

  createTaskStatus(params, router) {
    const url = "/api/taskStatuses";
    return this.CommonAPIService.postCall(url, params, router);
  }

  updateTaskStatus(id, params, router) {
    const url = `/api/taskStatuses/${id}`;
    return this.CommonAPIService.putCall(url, params, router);
  }

  deleteTaskStatus(id, router) {
    const url = `/api/taskStatuses/${id}`;
    return this.CommonAPIService.deleteCall(url, null, router);
  }

  listTaskOwners(router) {
    const url = "/api/taskOwners";
    return this.CommonAPIService.getCall(url, "", router);
  }

  createTaskOwner(params, router) {
    const url = "/api/taskOwners";
    return this.CommonAPIService.postCall(url, params, router);
  }

  updateTaskOwner(id, params, router) {
    const url = `/api/taskOwners/${id}`;
    return this.CommonAPIService.putCall(url, params, router);
  }

  deleteTaskOwner(id, router) {
    const url = `/api/taskOwners/${id}`;
    return this.CommonAPIService.deleteCall(url, null, router);
  }

  listTaskTimeSheet(router) {
    const url = "/api/taskTimesheets";
    return this.CommonAPIService.getCall(url, "", router);
  }

  createTaskTimesheet(params, router) {
    const url = "/api/taskTimesheets";
    return this.CommonAPIService.postCall(url, params, router);
  }

  updateTaskTimesheet(id, params, router) {
    const url = `/api/taskTimesheets/${id}`;
    return this.CommonAPIService.putCall(url, params, router);
  }

  deleteTaskTimesheet(id, router) {
    const url = `/api/taskTimesheets/${id}`;
    return this.CommonAPIService.deleteCall(url, null, router);
  }

  taskStatusList(router) {
    const url = "/api/taskStatusOptions";
    return this.CommonAPIService.getCall(url, "", router);
  }

  listByTaskCreator(id, router) {
    const url = `/api/createdBy/${id}`;
    return this.CommonAPIService.getCall(url, "", router);
  }

  list(router) {
    const url = "/api/tasks";
    return this.CommonAPIService.getCall(url, "", router);
  }

  create(params, router) {
    const url = "/api/tasks";
    return this.CommonAPIService.postCall(url, params, router);
  }

  getTaskById(id, router) {
    const url = `/api/tasks/${id}`;
    return this.CommonAPIService.getCall(url, "", router);
  }

  getTaskDetailsById(id, router) {
    const url = `/api/tasks/${id}/details`;
    return this.CommonAPIService.getCall(url, "", router);
  }

  update(id, params, router) {
    const url = `/api/tasks/${id}`;
    return this.CommonAPIService.putCall(url, params, router);
  }

  delete(id, router) {
    const url = `/api/tasks/${id}`;
    return this.CommonAPIService.deleteCall(url, null, router);
  }
}

export default TasksAPIService;
